import React, { useState } from 'react';
import { Scrollbar } from 'react-scrollbars-custom';
import ViewRow from './ViewRow';
import EmptyState from '../EmptyState/EmptyState';
import { Loading } from '../EntityAdvancedPermissionsTypes';
import { Box, DropdownLayout, listItemSelectBuilder } from '@wix/design-system';
import Avatar from './Avatar';
import PermissionsDropdown from '../PermissionsDropdown/PermissionsDropdown';
import { classes, st } from './ViewRow.st.css';
function PermissionsList(props) {
    const { onChange, className, items, emptyStateTitle, emptyStateDescription, loading, removePermissionCode, permissionRemovedMessage, isDashboard = false, modalAlertVisible = false, containerRef, } = props;
    const [permissionRemoved, setPermissionRemoved] = useState({
        status: false,
        id: '',
    });
    const [currentHighlightedOptionId, setCurrentHighlightedOptionId] = useState('');
    const filteredItems = items.filter((item) => item.selectedPermission !== props.removePermissionCode);
    const onChangeCheckRemoved = (data) => {
        setPermissionRemoved({
            status: data.permissionId === removePermissionCode,
            id: data.id,
        });
        if (onChange) {
            onChange(data);
        }
    };
    if (isDashboard) {
        const itemsList = filteredItems?.map((obj) => {
            const { description, id, role, selectedPermission, options, icon } = obj;
            const wsrPermissionChange = (permissionId) => {
                onChangeCheckRemoved({ permissionId, id });
            };
            const suffixIcon = (React.createElement(PermissionsDropdown, { isDashboard: isDashboard, disabled: false, options: options, value: selectedPermission, onChange: wsrPermissionChange, className: st(classes.wsrMaxHeight), shouldChangeColor: currentHighlightedOptionId === id, containerRef: containerRef }));
            return listItemSelectBuilder({
                id,
                prefix: React.createElement(Avatar, { icon: icon }),
                title: role,
                subtitle: description,
                suffix: suffixIcon,
                label: role,
            });
        });
        return (React.createElement(Box, { verticalAlign: "middle", height: modalAlertVisible ? '61%' : '87%', marginLeft: '12px', marginRight: '6px', overflow: 'auto', className: st(classes.wsrPermissionsDropdownBox) }, !filteredItems.length && loading === Loading.Success ? (React.createElement(EmptyState, { mainTitle: emptyStateTitle, description: emptyStateDescription, isDashboard: isDashboard })) : (React.createElement(DropdownLayout, { options: itemsList, visible: true, inContainer: true, maxHeightPixels: '345px', overflow: 'visible', onSelect: (option) => {
                setCurrentHighlightedOptionId(option?.id);
            } }))));
    }
    return !filteredItems.length && loading === Loading.Success ? (React.createElement(EmptyState, { mainTitle: emptyStateTitle, description: emptyStateDescription, className: className })) : (React.createElement(Scrollbar, { native: true, translateContentSizeYToHolder: true, noScrollX: true, className: className },
        React.createElement("div", null,
            filteredItems.map((k) => {
                return (React.createElement(ViewRow, { containerRef: containerRef, ...k, key: k.id, onChange: onChangeCheckRemoved }));
            }),
            permissionRemoved.status && (React.createElement("span", { className: "sr-only", role: "alert", key: `permissionremoved${permissionRemoved.id}` }, permissionRemovedMessage)))));
}
export default PermissionsList;
//# sourceMappingURL=PermissionsList.js.map